import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button, Form, TextField, TripletTextField, ItemPage } from '../common';
import { getLangValue } from '../common/functions';
import config from '../config';


const Title = styled(ItemPage.Title)`
    text-align: center !important;
`;

const Actions = styled(ItemPage.Actions)`
    justify-content: center;
`;

const Container = styled.div`
    text-align: center !important;
`;


const getSubTitle = (lottery) => {
    if(lottery.tags?.indexOf('internal.nuorelle-siivet.lottery') !== -1) {
        return 'Syötä arvasta löytyvä internetkoodi:';
    }

    if(lottery.codes_check_type !== 2) {
        return 'Syötä arvasta löytyvät tarkistusnumerot.';
    }

    return 'Syötä arvasta löytyvät tarkistusnumero.';
};

const EnterNumbers = ({
    lottery,
    claimPrize,
    onContinue,
    onBack,
    drawerOpen,
    onDrawerOpen,
    onDrawerClose
}) => {
    useEffect(() => {
        const handleGlobalKeyDown = (event) => {
            if (event.key === 'Enter') {
                document.getElementById('enterNumbersFormButton').click();
            }
        };

        window.addEventListener('keydown', handleGlobalKeyDown);

        return () => {
            window.removeEventListener('keydown', handleGlobalKeyDown);
        };
    }, []);

    return (
        <Container>
            <Title>{getLangValue(lottery.names, 'fi')}</Title>
            <ItemPage.Description>
                <ItemPage.Text mobileCenter>
                    { getSubTitle(lottery) }
                </ItemPage.Text>
                <Form action={`${config.backendAddress}/api/v1/lotteries/${lottery.id}/claims/`} id='numberForm' withRelativeSpinner onResponse={(prize) => onContinue(prize)}>
                    <Form.Section>
                        {lottery.codes_check_type === 2 &&
                         <TripletTextField
                             name='code_b'
                             label='Tarkistusnumero'
                             autoComplete='off'
                             required
                             style={{
                                 width: '100%',
                                 maxWidth: 400
                             }} />
                        }
                        {lottery.codes_check_type !== 2 && <TextField type='tel' name='code_a' label='Tarkistusnumero 1' autoComplete='off' required style={{ width: '100%', maxWidth: 400 }} />}
                        {lottery.codes_check_type === 4 && <TextField type='tel' name='code_b' label='Tarkistusnumero 2' required autoComplete='off' style={{ width: '100%', maxWidth: 400 }} />}
                    </Form.Section>
                </Form>
            </ItemPage.Description>
            <Actions>
                <Button id='enterNumbersFormButton' type='submit' form='numberForm'>Jatka</Button>
            </Actions>
        </Container>
    );
};

export { EnterNumbers };
